<div class="settings-tools">
  <ul class="nav nav-tabs line-tab fixnav">
    <li class="nav-item" role="presentation" *ngFor="let option of tabList">
      <a
        [routerLink]="'../' + toolSettingsData[option].type"
        role="tab"
        data-toggle="tab"
        [className]="'nav-link ' + (isCurrentPath(toolSettingsData[option].type) ? 'active' : '')"
        [attr.aria-selected]="isCurrentPath(toolSettingsData[option].type)"
        *ngIf="true || userPermissions[toolSettingsData[option].permission]?.view">
        {{ toolSettingsData[option].label }}
      </a>
    </li>
  </ul>
  <ng-container *ngIf="true || userPermissions[toolSettingsData[currentPath].permission]?.view">
    <div class="tab-content mainTabContent">
      <app-tool-settings-bar
        [toolSettingsData]="toolSettingsData[currentPath]"
        [editAccess]="userPermissions.tools_setting.edit"
        (search)="performSearch($event)"
        (create)="performCreate($event)"
        (exportSettings)="performBatchExport($event)"></app-tool-settings-bar>

      <div class="tab-pane fade show active" role="tabpanel">
        <app-tool-settings-table
          [headers]="toolSettingsData[currentPath]"
          [rows]="toolSettingsData[currentPath].data"
          [sortData]="searchParams.order"
          (action)="handleAction($event)"></app-tool-settings-table>
        <app-tool-settings-paging
         [customClass]="'tool-settings-paging--custom'"
          [links]="toolSettingsPagingData[currentPath]"
          (navigation)="performPaging($event)"></app-tool-settings-paging>
      </div>
    </div>
  </ng-container>
</div>

<!-- tools dialog prompt -->
<app-dialog id="tools-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title" id="exampleModalLabel">{{ dialogRecord.actionName }} {{ dialogRecord.settingType }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'status' || dialogRecord.actionType === 'delete'"
      >Are you sure you want to {{ dialogRecord.actionName | lowercase }} <b>{{ dialogRecord.data.name }}</b
      >?</span
    >
    <span *ngIf="dialogRecord.actionType === 'create' || dialogRecord.actionType === 'edit'">
      <span *ngIf="dialogRecord.settingType.toLowerCase().includes('shop'); else standardPrompts">
        <div class="col-12">
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" [(ngModel)]="newRecord.name" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Address Line 1</label>
            <input type="text" class="form-control" [(ngModel)]="newRecord.addressLine1" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Address Line 2</label>
            <input type="text" class="form-control" [(ngModel)]="newRecord.addressLine2" />
          </div>
        </div>
        <div class="shop-locations row">
          <div class="col-8">
            <div class="form-group shop-location-city">
              <label>City</label>
              <input type="text" class="form-control" [(ngModel)]="newRecord.city" />
            </div>
          </div>
          <div class="col-4">
            <div class="form-group shop-location-state">
              <label>State</label>
              <input type="text" class="form-control" [(ngModel)]="newRecord.state" />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group shop-location-zip">
            <label>Zip Code</label>
            <input type="text" class="form-control" [(ngModel)]="newRecord.zipCode" />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Status</label><br />
            <app-toggle
              [(enabled)]="newRecord.enabled"
              (toggle)="handleToggle($event)"
              [allowChanges]="true"></app-toggle>
          </div>
        </div>
      </span>

      <ng-template #standardPrompts>
        <div class="col-12">
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" [(ngModel)]="newRecord.name" />
          </div>
        </div>
        <div class="col-12" *ngIf="dialogRecord.settingType.toLowerCase().includes('category')">
          <div class="form-group">
            <label>Asset Class</label>
            <select
              [(ngModel)]="newRecord.assetClassId"
              name="toolAssetClassId"
              id="toolAssetClassId"
              (change)="setDataToControl('toolAssetClassId', toolAssetClassId.value)"
              [ngModelOptions]="{ standalone: true }"
              class="form-control select2 generalLocked"
              #toolAssetClassId>
              <option *ngFor="let assetClass of assetClasses" value="{{ assetClass.id }}">
                {{ assetClass.name }}
              </option>
            </select>
            <!-- <div style="width: 0 !important;  height: 0 !important; overflow: hidden !important;">
                            <input type="text" [(ngModel)]="newRecord.toolAssetClassId" name="toolAssetClassId"
                                (blur)='setDataToControl("toolAssetClassId", toolAssetClassId.value)'
                                [ngModelOptions]="{standalone: true}">
                        </div>
                         <select  [(ngModel)]="newRecord.toolAssetClassId" class="form-control" >
                                        <option *ngFor="let assetClass of assetClasses" [value]="assetClass.id">{{assetClass.name}}</option>
                                      </select> -->
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Description</label>
            <textarea class="form-control" rows="4" [(ngModel)]="newRecord.description"></textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Status</label><br />
            <app-toggle
              [(enabled)]="newRecord.enabled"
              (toggle)="handleToggle($event)"
              [allowChanges]="true"></app-toggle>
          </div>
        </div>
      </ng-template>
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary ml-3" id="tools-dialog_btn-ok">Continue</button>
  </span>
</app-dialog>
